/* step 15: Saved (wishlist): phone drawer and desktop drawer. Created by the step 01 gate, Oct 17, 2026. Owner: step 15 only. Guard calls into other steps (if (window.X) ...). */

/* C5, C6: the real window.pbsSavedDrawer is defined in podbysoni-header.js and window.pbsSaved in
   podbysoni-brand.js. Both load (deferred) before this file, via pbs-marquee.liquid, so these
   placeholders only apply if one of them failed to load. */
window.pbsSavedDrawer = window.pbsSavedDrawer || { open: function () {}, close: function () {} };
window.pbsSaved = window.pbsSaved || { read: function () { return []; }, remove: function (id) {} };
